import { InboxBatchRewardsDto, InboxDto, InboxVersion } from '@services/_api';
import client from '@services/client';

// Mirrors @lib/services/cstool/inbox.service.ts's registerTask() exactly - same request
// shape, same "let the browser set the multipart boundary" header override - just pointed
// at this feature's own chunking-aware endpoint instead.
export const registerBatchTask = (version: InboxVersion, params: InboxDto) =>
  client.api.inboxBatchPlayersControllerRegister(version, params, {
    headers: { 'Content-Type': undefined } as any,
  });

// Plain JSON (no file upload) - each player in params.players carries its own rewards, sent
// straight through to cats-server's ToolInboxCreateBatchHandler.
export const registerBatchRewardsTask = (params: InboxBatchRewardsDto) =>
  client.api.inboxBatchPlayersControllerRegisterWithRewards(params);
